export default __webpack_public_path__ + "static/media/nft-example-3.f8ae49c6.jpg";